<template>
  <div class="tab-content"
       v-show="name === selectedTab">
    <slot></slot>
  </div>
</template>

<script setup>

import {useStore} from 'vuex';
const store = useStore();

const props = defineProps({

  name: {type: String},
  selectedTab: {type: String},
  badgeData: null,
  iconColor: '',
  style:''
})

</script>

<style scoped>

</style>
